export function mapLeadRequestToResponse(topJson) {
  const lead = topJson.lead || topJson;

  return {
    // map `_id` -> `id`
    id: lead._id || null,

    // direct mappings
    contact_name: lead.contact_name,
    contact_phone: lead.contact_phone,
    country_code: lead.country_code,
    contact_email: lead.contact_email,
    work_contact_email: lead.work_contact_email || "",
    dob: lead.dob,
    gender: lead.gender,
    loan_type: lead.loan_type,
    address1: lead.address1 || "",
    address2: lead.address2 || "",
    work_address1: lead.work_address1 || "",
    work_address2: lead.work_address2 || "",
    city: lead.city || "",
    state: lead.state || "",
    company_type: lead.company_type || "",
    gst: lead.gst || "",
    turnover: lead.turnover || 0,
    business_vintage: lead.business_vintage || 1,
    pincode: lead.pincode,
    work_pincode: lead.work_pincode || "",
    profession_type: lead.profession_type,
    monthly_income: lead.monthly_income,
    annual_income: lead.annual_income || 0,
    pancard: lead.pancard,
    salary_mode: lead.salary_mode,
    alliance_id: lead.alliance_id,
    aff_id: lead.aff_id,
    utm_source: lead.utm_source,
    utm_medium: lead.utm_medium || null,
    utm_term: lead.utm_term || null,
    ads_name: lead.ads_name || null,
    kyc_consent: lead.kyc_consent,
    kyc_consent_datetime: {
      $date: lead.kyc_consent_datetime, // wrap inside `$date`
    },
    tracking_id: lead.tracking_id,

    // system flags from top JSON
    is_clicked: lead.is_clicked || null,
    is_stage1_completed: lead.is_stage1_completed || "false",
    is_stage2_completed: lead.is_stage2_completed || "false",
    is_stage3_completed: lead.is_stage3_completed || "false",
    is_stage4_completed: lead.is_stage4_completed || false,
    is_stage5_completed: lead.is_stage5_completed || "false",
    is_mobile_verify_completed: lead.is_mobile_verify_completed || "false",
    bank_statement_file: lead.bank_statement_file || [],
    electricity_bill_file: lead.electricity_bill_file || [],
    from_preapprove: lead.from_preapprove || false,
    from_business_lead: lead.from_business_lead || false,
    disbursement_amount: lead.disbursement_amount || 0,
    disburse_report_tags: lead.disburse_report_tags || [],
    is_company: lead.is_company,
    is_gst: lead.is_gst || false,
    is_wip: lead.is_wip || false,
    is_disbursed: lead.is_disbursed || false,
    is_rejected: lead.is_rejected || false,
    is_duplicate: lead.is_duplicate || false,
    is_processed: lead.is_processed || false,
    is_failed: lead.is_failed || false,
    rejected_count: lead.rejected_count || 0,
    offers_count: lead.offers_count || 0,
    total_response: lead.total_response || 0,
    all_responses: lead.all_responses || 0,
    is_processed_by_lender: lead.is_processed_by_lender || true,
    is_landt_finbud_success: lead.is_landt_finbud_success || false,
    is_landt_finbud_call_done: lead.is_landt_finbud_call_done || false,
    is_deleted: lead.is_deleted || false,

    latitude:lead.latitude,
    longitude:lead.longitude,
    ip_address:lead.ip_address,

    // extra field only in bottom JSON
    bureau_score_categories: lead.bureau_score_categories || null,
  };
}
